
export default "/assets/photo-mini.8989a3f2.svg"